import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Autocomplete, Typography, FormControl, OutlinedInput, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import NeighbourhoodHeader from './NeighbourhoodHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { debounce } from 'lodash';


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    community_id: any;
    showLoader: boolean;
    pageSize: number;
    pickups: any[];
    rowCount: any;
    hierarchies: any;
    community_pickups_list: any[];
    filter: any;
}

class NeighbourhoodPickups extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            community_id: this.props.match.params.id,
            showLoader: false,
            pageSize: 20,
            pickups: [],
            rowCount: 20,
            hierarchies: [],
            community_pickups_list: [],
            filter: '',
        }
    }
    public componentDidMount(): void {
        this.fetchAccessibleHierarchiesList();
        this.fetchAllCommunityPickups();
    }

    public fetchAccessibleHierarchiesList() {
        axios.get(`accessibleHierarchiesList`).then(response => {
            let hierarchies: any = [];
            if (response.data.success) {
                response.data.data.map((hierarchy: any) => {
                    hierarchies[hierarchy.id] = hierarchy;
                });
            }
            this.setState({ hierarchies: hierarchies });
            // console.log(this.state.hierarchies);
        })
    }

    public fetchAllCommunityPickups(page: number = 0, limit: number = this.state.pageSize) {
        this.setState({showLoader: true});
        let body = {
            "community_id": this.state.community_id,
            "filter": this.state.filter,
            "hierarchies": this.props.user.selectedHierarchyIds,
            "ignore_hierarchy": true,
            "limit": limit,
            "page": page+1,
        }
        axios.post(`filterPickups`, body, {headers: {"Content-Type": "application/json"}}).then((response: any) => {
            if(response.data.success){
                let data = response.data.data;
                this.setState({showLoader: false, rowCount: data.total});
                let pickups: any = [];
                data.data.map((pickup: any) => {
                    let customClassNames : any = [];
                    if(pickup.pickup_status == 'complete' && pickup.payment_status == 'complete'){
                        customClassNames.push('pickupCompleteClass');
                    } else {
                        customClassNames.push('pickupPendingClass');
                    }
                    pickups.push({
                        "id": pickup.id,
                        "community_name": pickup.community.name,
                        "pickup_date": pickup.pickup_date,
                        "pickup_slot": pickup.pickup_slot,
                        "cust_name": pickup.cust_name,
                        "cust_phone": pickup.cust_phone,
                        "agent_name": pickup.agent_name,
                        "pickup_status": pickup.pickup_status,
                        "payment_status": pickup.payment_status,
                        "updated_at": pickup.updated_at, 
                        "customClassNames": customClassNames.join(" ")
                    })
                })
                this.setState({community_pickups_list: [...pickups]});
                // console.log("data", this.state.community_pickups_list);

            } else {
                this.setState({ showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchAllCommunityPickups(page,limit);
      }, 800);

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const dateConversion = (date: any) => {
            if (!date) return;
            var time = Date.parse(date),
                timeNow = new Date().getTime(),
                difference = timeNow - time,
                seconds = Math.floor(difference / 1000),
                minutes = Math.floor(seconds / 60),
                hours = Math.floor(minutes / 60),
                days = Math.floor(hours / 24);
            if (days > 1) {
                return days + " days ago";
            } else if (days == 1) {
                return "1 day ago"
            } else if (hours > 1) {
                return hours + " hours ago";
            } else if (hours == 1) {
                return "an hour ago";
            } else if (minutes > 1) {
                return minutes + " minutes ago";
            } else if (minutes == 1){
                return "a minute ago";
            } else {
                return "a few seconds ago";
            }
        }
       

        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 100
            },
            {
                headerName: t("Pickup Slot"),
                field: "pickup_date",
                width: 250,
                renderCell: (params: GridCellParams) => (
                    // <Typography className={(params.row.type == 'User') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.type == 'User' ? "User" : "Manager"}</Typography>
                    <Typography>{params.row.pickup_date+" ("+params.row.pickup_slot+")"}</Typography>
                )
            },
            {
                headerName: t("Customer"),
                field: "cust_name",
                width: 150
            },
            {
                headerName: t("Mobile"),
                field: "cust_phone",
                width: 200
            },
            {
                headerName: t("Agent"),
                field: "agent_name",
                width: 200
            },
            {
                headerName: t("Status"),
                field: "pickup_status",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.pickup_status == 'complete') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.pickup_status == 'complete' ? "Complete" : "Pending"}</Typography>
                )
            },
            {
                headerName: t("Payment"),
                field: "payment_status",
                width: 100,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.payment_status == 'complete') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.payment_status == 'complete' ? "Complete" : params.row.payment_status == "Pending" ? "Pending" : ""}</Typography>
                )
            },
            {
                headerName: t("Updated"),
                field: "updated_at",
                width: 200,
                renderCell: (params: GridCellParams) => (
                    <Typography>{dateConversion(params.row.updated_at)}</Typography>
                )
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                    // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <NeighbourhoodHeader user={this.props.user}/>
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={5} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t(`List of ${this.state.community_pickups_list[0]?.community_name} Pickups`)}</Typography>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Link to={`/neighbourhood/community-list/${this.state.community_id}/users`}>
                                            <Button variant="contained" size="small"   
                                            // onClick={() => this.props.history.push(`/neighbourhood/pickups/${this.state.community_id}`)}
                                            >
                                                Users
                                            </Button>
                                        </Link>
                                        <Link to={`/neighbourhood/community-list/${this.state.community_id}`}>
                                            <Button variant="contained" size="small"   
                                                // onClick={() => this.props.history.push(`/neighbourhood/community-list/${this.state.community_id}`)}
                                            >
                                                Details
                                            </Button>
                                        </Link>
                                    </CardActions>
                                }
                            />

                            <CardContent>
                                <DataGrid
                                    aria-label={t("Agents List")}
                                    columns={columns}
                                    rows={this.state.community_pickups_list}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page: any) => this.fetchAllCommunityPickups(page)}
                                    onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchAllCommunityPickups(0, newPageSize); }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    autoHeight={true}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                    }}
                                    paginationMode="server"
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/operations/batch-pickups/group-pickups/pickup-details/' + params.id);
                                    }}
                                    className="clickableList"
                                    getRowClassName={(params: any) =>
                                        params.row.customClassNames
                                    }
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(NeighbourhoodPickups))